import { triggerQuickShopModal } from "../modal/handleQuickshopModal";

export default function handleBadge(elem) {
  const badgeHeight = $(elem).get(0).naturalHeight;
  const badgeWidth = $(elem).get(0).naturalWidth;

  if (badgeHeight === badgeWidth) return;
  if (badgeHeight > badgeWidth) {
    $(elem).addClass("badging__image--portrait");
  } else {
    $(elem).addClass("badging__image--landscape");
  }
}

// Product Badge Image Sizing to handle landscape/portrait icons
if ($(".js-product-badge").length > 0) {
  $(".js-product-badge").each((i, elem) => handleBadge(elem));
}
